export default __webpack_public_path__ + "static/process-1-92fdac0df27d7b42a9bdbe939532befc.jpg";